import { render, staticRenderFns } from "./IuguCardForm.vue?vue&type=template&id=1b562396&"
import script from "./IuguCardForm.vue?vue&type=script&lang=js&"
export * from "./IuguCardForm.vue?vue&type=script&lang=js&"
import style0 from "./IuguCardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports